










import { Vue, Component } from 'vue-property-decorator';
import Ubicacion from '@/pantallas/VerUbicacion/ubicacion.vue';

@Component({
  components: { Ubicacion },
})
export default class UbicacionPantalla extends Vue {}
